(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2513],{

/***/ 75747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OfferList; }
/* harmony export */ });
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75472);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76962);
/* harmony import */ var _OfferTile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51310);
/* harmony import */ var _ProductListItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57730);
/* harmony import */ var _ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54820);
/* harmony import */ var _ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










function OfferList(_ref) {
  var offers = _ref.offers,
      _ref$waveSpecialProdu = _ref.waveSpecialProductsGrouped,
      waveSpecialProductsGrouped = _ref$waveSpecialProdu === void 0 ? [] : _ref$waveSpecialProdu,
      showBySelection = _ref.showBySelection;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      offersShown = _useState[0],
      setOffersShown = _useState[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    getFilteredProducts();
  }, [showBySelection, offers, router.query]);
  if (!offers.length && !waveSpecialProductsGrouped.length) return null;

  function getSortedOffers() {
    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].catalog */ .Z.catalog) {
      return offers;
    }

    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].expensive */ .Z.expensive) {
      return lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default()(offers, 'price', 'desc');
    }

    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].cheap */ .Z.cheap) {
      return lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default()(offers, 'price', 'asc');
    }

    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].alphabetical */ .Z.alphabetical) {
      return lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default()(offers, 'name', 'asc');
    }
  }

  function getFilteredProducts() {
    var offersByBannerOptions = getSortedOffers();
    setOffersShown(offersByBannerOptions);
  }

  return (offersShown && offersShown.length !== 0 || waveSpecialProductsGrouped && waveSpecialProductsGrouped.length !== 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listHeader),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
        className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listTitle),
        children: "\u03A3\u03B1\u03C2 \u03C3\u03C5\u03BC\u03C6\u03AD\u03C1\u03B5\u03B9"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default().bannerContainer),
      children: [waveSpecialProductsGrouped.length !== 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: waveSpecialProductsGrouped.map(function (p, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ProductListItem__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            _product: p,
            itemListId: "Offers",
            itemListName: "\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2",
            positionInList: index + 1
          }, p._id);
        })
      }), offersShown.map(function (o) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_OfferTile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          offer: o
        }, o._id);
      })]
    })]
  });
}

/***/ }),

/***/ 14396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Offers; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(28833);
/* harmony import */ var _styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _components_CategoriesAside_CategoriesAside__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6551);
/* harmony import */ var _components_CategoriesBanner_CategoriesBanner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11848);
/* harmony import */ var _components_CategoriesSelect_CategoriesSelect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16723);
/* harmony import */ var _components_CustomMetaHead__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92536);
/* harmony import */ var _components_DeliveryBanner_DeliveryBanner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54196);
/* harmony import */ var _components_FavoritesAside_FavoritesAside__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79255);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31875);
/* harmony import */ var _components_Header_Header__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3266);
/* harmony import */ var _components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86894);
/* harmony import */ var _components_ProductsMenu_OfferList__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75747);
/* harmony import */ var _components_ProductsMenu_ProductMenu__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5903);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88362);
/* harmony import */ var _store_categories__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9266);
/* harmony import */ var _store_deliveryMode__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(34525);
/* harmony import */ var _store_productsCollection__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(67713);
/* harmony import */ var _store_productsSort__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(43660);
/* harmony import */ var _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(76962);
/* harmony import */ var _offers_module_scss__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(6089);
/* harmony import */ var _offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_offers_module_scss__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(85893);

























var __N_SSG = true;
function Offers(_ref) {
  var navigation = _ref.navigation,
      footerLinks = _ref.footerLinks,
      offers = _ref.offers,
      meta = _ref.meta;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_utils_bannerOptions__WEBPACK_IMPORTED_MODULE_18__/* ["default"].catalog */ .Z.catalog),
      showBySelection = _useState[0],
      setShowBySelection = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      numOfProducts = _useState2[0],
      setNumOfProducts = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      deliveryMode = _useState3[0],
      setDeliveryMode = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      waveSpecialProductsGrouped = _useState4[0],
      setWaveSpecialProductsGrouped = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      productCollections = _useState5[0],
      setProductCollections = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      categories = _useState6[0],
      setCategories = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      offersByCollectionType = _useState7[0],
      setOffersByCollectionType = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isCartVisible = _useState8[0],
      setIsCartVisible = _useState8[1];

  var slug = ['offers'];

  function findWaveProductsOffers(parentCategories, products) {
    if (!parentCategories.length) return;
    var productsInCategory = products.filter(function (p) {
      return p.offerType === 'web-only-amount' || p.offerType === 'web-only-percentage';
    });
    setWaveSpecialProductsGrouped(productsInCategory);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var subscriptionDeliveryMode = _store_deliveryMode__WEBPACK_IMPORTED_MODULE_15__/* ["default"].subscribe */ .Z.subscribe(setDeliveryMode);
    var productsCollection$ = _store_productsCollection__WEBPACK_IMPORTED_MODULE_16__/* ["default"].subscribe */ .Z.subscribe(setProductCollections);
    var isCartVisible$ = _store_cart__WEBPACK_IMPORTED_MODULE_13__/* ["default"].getIsVisble$ */ .ZP.getIsVisble$().subscribe(setIsCartVisible);
    var sortBy$ = _store_productsSort__WEBPACK_IMPORTED_MODULE_17__/* ["default"].subscribe */ .Z.subscribe(setShowBySelection);
    var categories$ = _store_categories__WEBPACK_IMPORTED_MODULE_14__/* ["default"].subscribe */ .Z.subscribe(setCategories);
    return function () {
      sortBy$.unsubscribe();
      categories$.unsubscribe();
      isCartVisible$.unsubscribe();
      productsCollection$.unsubscribe();
      subscriptionDeliveryMode.unsubscribe();
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!productCollections) return;
    if (!categories) return;
    var service = _store_deliveryMode__WEBPACK_IMPORTED_MODULE_15__/* ["default"].getValue */ .Z.getValue();
    var collectionType = _store_deliveryMode__WEBPACK_IMPORTED_MODULE_15__/* ["default"].getCollectionAsNumber */ .Z.getCollectionAsNumber(service);
    var mainCollectionType = collectionType.find(function (c) {
      return c === "900" || c === '751';
    });
    var offersInCollection = offers.filter(function (offer) {
      return offer.collectionTypes.includes(parseInt(mainCollectionType));
    });
    setOffersByCollectionType(offersInCollection);
    var allProductsCollection = _store_productsCollection__WEBPACK_IMPORTED_MODULE_16__/* ["default"].getProductsForCollections */ .Z.getProductsForCollections(collectionType);
    findWaveProductsOffers(categories, allProductsCollection);
  }, [productCollections, categories]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_CustomMetaHead__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      meta: meta
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
      className: (_styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().headerContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_Header_Header__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        navigation: navigation
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      navigation: navigation
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_DeliveryBanner_DeliveryBanner__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_CategoriesSelect_CategoriesSelect__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      slug: slug
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("main", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default().main), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, (_offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default().spaceOpenCart), isCartVisible)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default().mainLeft), (_offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default().listBanner)]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default().sticky)]),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_CategoriesBanner_CategoriesBanner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            onChangeOrderBy: function onChangeOrderBy(e) {
              return _store_productsSort__WEBPACK_IMPORTED_MODULE_17__/* ["default"].update */ .Z.update(e.target.value);
            },
            showBySelection: showBySelection,
            numOfProducts: numOfProducts,
            categoryName: 'Προσφορές',
            subCategoryName: null,
            slug: slug,
            deliveryMode: deliveryMode,
            isProductList: false
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("section", {
          className: (_offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default().mainContent),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
            className: (_offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default().hideOnSmallScreen),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
              className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default().sticky), (_offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default().categoriesAsideTop)]),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_FavoritesAside_FavoritesAside__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_CategoriesAside_CategoriesAside__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                slug: slug
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
            className: (_offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default().offerListWrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
              className: (_offers_module_scss__WEBPACK_IMPORTED_MODULE_21___default().offerListContainer),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_ProductsMenu_OfferList__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                offers: offersByCollectionType,
                categories: categories,
                waveSpecialProductsGrouped: waveSpecialProductsGrouped,
                showBySelection: showBySelection
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_ProductsMenu_ProductMenu__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
              isSecondLevelPage: false,
              isOfferListPage: true,
              categories: categories,
              productCollections: productCollections,
              slug: slug,
              setNumOfProducts: setNumOfProducts,
              deliveryMode: deliveryMode,
              offers: offers,
              showBySelection: showBySelection
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 64666:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offers",
      function () {
        return __webpack_require__(14396);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6089:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"offers_main__5BFjK","mainLeft":"offers_mainLeft__b_wmD","mainContent":"offers_mainContent__bu7so","defaultContainer":"offers_defaultContainer__vp9WM","listContainer":"offers_listContainer__GvH7s","listBannerOffers":"offers_listBannerOffers__zWyvx","listBannerSearch":"offers_listBannerSearch__3NIDZ","mainList":"offers_mainList__913K5","listSearch":"offers_listSearch__psc6T","sticky":"offers_sticky__VxnOS","categoriesAsideTop":"offers_categoriesAsideTop__mBEVk","categoriesAsideProductDetails":"offers_categoriesAsideProductDetails__uCWg3","spaceOpenCart":"offers_spaceOpenCart__CKYCF","productsListContainer":"offers_productsListContainer__GyCFF","offerListWrapper":"offers_offerListWrapper__GGHl2","offerListContainer":"offers_offerListContainer__Ptw4d","hideOnSmallScreen":"offers_hideOnSmallScreen__zb_V5"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,260,2013,3253,3996,4843,6864,9950,7730,9878,3231,9579,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(64666); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);